export const TRADE_CATEGORIES = [
  {
    id: "handloom-home",
    n: "01",
    name: "Handloom & Home Furnishing",
    items: ["Kerchief", "Lungies", "Vestis & Dhoties", "Thundu (Angavasthram)", "Swamy Items", "Napkins & Towels", "Shawls & Ponnadai", "Katchi Items", "Mull & Gada", "Door & Window Screens", "Bedsheets", "Bedspreads", "Blankets", "Pillow Covers"],
  },
  {
    id: "blouse-women",
    n: "02",
    name: "Blouse & Women Wear",
    items: ["Blouse & Lining Materials", "Blouse Readymade & Bits", "Inskirt Readymade & Fabric", "Night Gowns Readymade & Bits"],
  },
  {
    id: "sarees",
    n: "03",
    name: "Sarees",
    items: ["Poonam", "Renial", "Chiffon", "Voil", "Cotton", "Plain Sarees", "Lehengas"],
  },
  {
    id: "women-western",
    n: "04",
    name: "Women Western Wear",
    items: ["Churidar Readymade & Materials", "Kurtis", "Dupatta", "Bottom Wear"],
  },
  {
    id: "men-wear",
    n: "05",
    name: "Menswear",
    items: ["Shirts", "Pants", "Jeans", "T-Shirts", "Trackpants & Shorts"],
  },
  {
    id: "shirtings-suitings",
    n: "06",
    name: "Shirtings & Suitings",
    items: ["Shirting Fabrics", "Suiting Fabrics"],
  },
  {
    id: "uniforms",
    n: "07",
    name: "Uniforms",
    items: ["Uniform Fabrics", "Govt. Readymade Uniforms"],
  },
  {
    id: "innerwear",
    n: "08",
    name: "Innerwear",
    items: ["Vests", "Briefs & Trunks", "Boxers", "Camisoles", "Panties", "Thermals"],
  },
];

export const ENQUIRY_CATEGORIES = [
  "Handloom & Home Furnishing",
  "Blouse & Women Wear",
  "Sarees",
  "Women Western Wear",
  "Menswear",
  "Shirtings & Suitings",
  "Uniforms",
  "Innerwear",
  "Multiple Categories",
];

export const CONTACT = {
  phones: [
    { label: "Customer Care", display: "+91 98898 85321", href: "tel:+919889885321" },
    { label: "Sales", display: "+91 98898 86321", href: "tel:+919889886321" },
  ],
  whatsapp: "https://wa.me/919952080021?text=Thanks%20for%20contacting%20Praveen%20Textiles!%20Let%20us%20know%20what%20you%27re%20looking%20for%20%E2%80%94%20product%20and%20quantity%20%E2%80%94%20and%20we%27ll%20get%20back%20to%20you%20shortly%20with%20stock%20and%20rates.",
  email: "sales@praveentextiles.com",
  address: "Old No.21, New No.53, M.C. Road, Old Washermenpet, Chennai — 600021, Tamil Nadu, India",
  hours: "Mon–Sat · 10:00 AM – 8:00 PM",
};
